import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  user: any;
  isReadOnly: boolean;

  bankId: string;
  email: string;
  profileForm: FormGroup;

  pFname: string;
  pLname: string;
  pPhoneNo: string;
  pEmail: string;

  pstate: string;
  pvillage: string;
  ppincode: string;
  paddressL1: string;
  paddressL2: string;
  pdistrict: string;

  branchname: string;
  bname: string;
  accno: string;
  ifsc: string;
  panNo: string;
  gstNo: string;

  baddressL1: string;
  baddressL2: string;
  bvillage: string;
  bdistrict: string;
  bstate: string;
  bpincode: string;

  profileSubmitBtnClicked: boolean = false;

  constructor(
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.profileForm = this.fb.group({
      pFname: [
        this.pFname,
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('^[a-zA-Z ]*$')
        ],
      ],
      pLname: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z ]*$')
        ],
      ],
      pdistrict: [
        '',
        [],
      ],
      pstate: [
        '',
        [],
      ],
      pvillage: [
        '',
        [],
      ],
      ppincode: [
        '',
        [],
      ],
      paddressL1: [
        '',
        [],
      ],
      paddressL2: [
        '',
        [],
      ],
    });

    this.setFetchUserDetails();
  }

  setFetchUserDetails() {
    this.isReadOnly = true;

    this.auth.getProfile().subscribe(
      (profile) => {
        this.user = profile['user'];
        this.destructureUserValues();

        if (this.user['accountStatus'] == 'inactive') {
          window.location.href = '/completeprofile';
        }
      },
      (err) => {
        // this.router.navigateByUrl('/login');
        this.toastr.error('Something went wrong');
        console.log(err);
      }
    );
  }

  destructureUserValues() {
    // Keep the original fetched data unchanged
    // Easy to revert, in case if the user chooses to cancel in middle of editing profile
    const userObj = { ...this.user };
    console.log("%c Line:125 🍞 userObj", "color:#fca650", userObj);

    this.bankId = userObj.bankId;
    this.email = userObj.email;

    // Contacter Person basic details
    this.pFname = userObj.pFname;
    this.pLname = userObj.pLname;
    this.pPhoneNo = userObj.pPhoneNo;
    this.pEmail = userObj.pEmail;

    this.profileForm.patchValue({ pFname: this.pFname });
    this.profileForm.patchValue({ pLname: this.pLname });

    // Contact Person Address
    this.pstate = userObj.paddress.pstate;
    this.pvillage = userObj.paddress.pvillage;
    this.ppincode = userObj.paddress.ppincode;
    this.paddressL1 = userObj.paddress.paddressL1;
    this.paddressL2 = userObj.paddress.paddressL2;
    this.pdistrict = userObj.paddress.pdistrict;

    this.profileForm.patchValue({ pstate: this.pstate });
    this.profileForm.patchValue({ pvillage: this.pvillage });
    this.profileForm.patchValue({ ppincode: this.ppincode });
    this.profileForm.patchValue({ paddressL1: this.pLname });
    this.profileForm.patchValue({ paddressL2: this.paddressL2 });
    this.profileForm.patchValue({ pdistrict: this.pdistrict });


    // Bank Details
    this.branchname = userObj.bankDetails.branchname;
    this.bname = userObj.bankDetails.bname;
    this.accno = userObj.bankDetails.accno;
    this.ifsc = userObj.bankDetails.ifsc;
    this.panNo = userObj.bankDetails.panNo;
    this.gstNo = userObj.bankDetails.gstNo;

    // Bank Address
    this.baddressL1 = userObj.baddress.baddressL1;
    this.baddressL2 = userObj.baddress.baddressL2;
    this.bvillage = userObj.baddress.bvillage;
    this.bdistrict = userObj.baddress.bdistrict;
    this.bstate = userObj.baddress.bstate;
    this.bpincode = userObj.baddress.bpincode;
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

  onCancelEdit() {
    this.isReadOnly = true;
    this.destructureUserValues();
  }

  onProfileSubmit() {
    const obj = {
      pFname: this.profileForm.get('pFname').value,
      pLname: this.profileForm.get('pLname').value,
      pstate: this.profileForm.get('pstate').value,
      pvillage: this.profileForm.get('pvillage').value,
      ppincode: this.profileForm.get('ppincode').value,
      paddressL1: this.profileForm.get('paddressL1').value,
      paddressL2: this.profileForm.get('paddressL2').value,
      pdistrict: this.profileForm.get('pdistrict').value,
    };
    console.log("%c Line:196 🥑 obj", "color:#ea7e5c", obj);

    this.profileSubmitBtnClicked = true;
    this.auth.editProfile(obj).subscribe(
      () => {
        this.profileSubmitBtnClicked = false;
        this.toastr.success('Profile edited successfully.');
        this.setFetchUserDetails();
      },
      (error) => {
        this.profileSubmitBtnClicked = false;
        console.error(error);
        this.setFetchUserDetails();
        this.toastr.error('Something went wrong! Please try again later.');
      }
    );
  }
}
